import React, { useEffect, useState } from "react";
import Steps from "../../Steps";
import Button from "../../../../common/Button";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import { useParams } from "react-router-dom";
import {
  classificationResultCalculation,
} from "./data";
import { useDispatch, useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import Dropdown from "../../../../common/Dropdown";
import { treatmentPlanOptions } from "../../../create/options";
import ResultCard from "./result-card";
import { updateClinicalService } from "../../../../../redux/modules/clinical-services/actions";
import SubNavigation from "../../common/sub-navigation";
import { getValidStep } from "../../../text/data";

const TreatmentResult = () => {
  const { clinicalServiceObj, clinicalServiceSteps } = useSelector((state) => state.clinicalService);
  const dispatch = useDispatch();
  const { serviceId } = useParams();
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [frequencyOfSymptoms, setFrequencyOfSymptoms] = useState();
  const [levelOfSeverity, setLevelOfSeverity] = useState();
  const [result, setResult] = useState({
    value: "myResults",
    label: "My Results",
  });
  const [classificationResult, setClassificationResult] = useState("");

  useEffect(() => {
    if (clinicalServiceObj.initialAssessment.initialAssessmentForm.treatment) {
      let treatment =
        clinicalServiceObj?.initialAssessment?.initialAssessmentForm?.treatment;
      setFrequencyOfSymptoms(treatment?.frequencyOfSymptoms);
      setLevelOfSeverity(treatment?.levelOfSeverity);
    }
  }, [clinicalServiceObj.initialAssessment.initialAssessmentForm]);

  useEffect(() => {
    handleResults();
  }, [frequencyOfSymptoms, levelOfSeverity]);

  const onNext = () => {
    if (currentStep <= clinicalServiceSteps.length) {
      const { nextStep, nextSubStep } = getValidStep(clinicalServiceSteps, currentStep, currentSubStep, 1);
      const updatedSteps = {
        currentStep: nextStep,
        currentSubStep: nextSubStep,
        serviceSteps: clinicalServiceSteps
      };
      dispatch(updateClinicalService(serviceId, updatedSteps));
    }
  };

  const onPrevious = () => {
    const { nextStep, nextSubStep } = getValidStep(clinicalServiceSteps, currentStep, currentSubStep, -1);
    const updatedSteps = { currentStep: nextStep, currentSubStep: nextSubStep };
    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  const handleResults = () => {
    let result = classificationResultCalculation(
      frequencyOfSymptoms,
      levelOfSeverity
    );
    if (result === "Mild Intermittent") {
      setClassificationResult("Mild Intermittent");
    } else if (result === "Moderate to Severe Intermittent") {
      setClassificationResult("Moderate to Severe Intermittent");
    } else if (result === "Mild Persistent") {
      setClassificationResult("Mild Persistent");
    } else if (result === "Moderate to Severe Persistent") {
      setClassificationResult("Moderate to Severe Persistent");
    }
  };

  const typeOfResults = [
    {
      title: "Mild Intermittent",
      subtitle:
        "Symptoms less than 4 days per week OR less than 4 consecutive weeks.",
      content: () => (
        <div className="flex flex-col space-y-2">
          <div className="flex space-x-2 ">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms DO NOT interfere with daily activities (work, school,
              sport, leisure).
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms are not bothersome.
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms have LITTLE to NO effect on sleep.
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Moderate to Severe Intermittent",
      subtitle:
        "Symptoms less than 4 days per week OR less than 4 consecutive weeks.",
      content: () => (
        <div className="flex flex-col space-y-2">
          <div className="flex space-x-2 ">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms interfere significantly in performance of normal daily
              activities.
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms are bothersome.
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms DISTURB sleep.
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Mild Persistent",
      subtitle:
        "Symptoms more than 4 days per week OR more than 4 consecutive weeks.",
      content: () => (
        <div className="flex flex-col space-y-2">
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms DO NOT interfere with daily activities (work, school,
              sport, leisure).
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms are not bothersome.
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms have LITTLE to NO effect on sleep.
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Moderate to Severe Persistent",
      subtitle:
        "Symptoms more than 4 days per week OR more than 4 consecutive weeks.",
      content: () => (
        <div className="flex flex-col space-y-2">
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms interfere significantly in performance of normal daily
              activities.
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms are bothersome.
            </p>
          </div>
          <div className="flex space-x-2">
            <ReactSVG
              src={"/icons/result-radio.svg"}
              className="w-[10px] mt-2"
            />
            <p className="text-gray-800 text-[18px] leading-[28px]">
              Symptoms DISTURB sleep.
            </p>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications />
          <div className="flex flex-1 w-full h-[668px] overflow-y-auto scroll-smooth ">
            <div className="w-full gap-5">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Allergic Rhinitis Results
                </h4>
                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div className="flex flex-col">
                <Dropdown
                  onChange={setResult}
                  selected={result}
                  options={treatmentPlanOptions}
                />
                <div className="grid grid-flow-col auto-cols-[480px] gap-[30px] scroll-smooth overflow-auto pt-8 pb-2">
                  {typeOfResults.map((resultObject, index) => {
                    if (
                      result.value === "myResults" &&
                      classificationResult === resultObject.title
                    ) {
                      return (
                        <ResultCard
                          key={index}
                          title={resultObject.title}
                          subtitle={resultObject.subtitle}
                          content={() => resultObject.content()}
                          active={classificationResult === resultObject.title}
                        />
                      );
                    } else if (result.value !== "myResults") {
                      return (
                        <ResultCard
                          key={index}
                          title={resultObject.title}
                          subtitle={resultObject.subtitle}
                          content={() => resultObject.content()}
                          active={classificationResult === resultObject.title}
                        />
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between space-x-4 rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
            }}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px]`}
            onClick={() => {
              onNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TreatmentResult;
